import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import "moment/locale/zh-cn";
import "./index.less";
import App from "./App.js";

ReactDOM.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>,
  document.getElementById("root")
);
